import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";

const MaterialHandled = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});
    
    let response34 = useInvoke("WebApps", "34", {});
    
    const[rows, setRows] = useState([]);
    const[columns, setColumns] = useState([]);

    

    useEffect(() => {

        //get materials handled
        if (response34.data.payload != undefined) {
            let myData = JSON.parse(response34.data.payload).data;
            let rowsList = [];

            myData.forEach((entry, index) => { 

              let row = [
                {type: "link", content: {text: `${entry[1]}`, link: `/MaterialHandled/Edit/${entry[0]}`}}, 
                {type: "text", content: {text: `${entry[2]}`}},
                {type: "text", content: {text: `${entry[3]}`}}

              ];
              rowsList.push(row);
            });
            setColumns(["Material Handled", "Instructions", "Date Added"]);
            setRows(rowsList);
        }

    }, [response34.data.payload]);

    document.title = "Materials Handled";
    return ( 
        <div className="Materials Handled">
            {user["email"] != undefined && 
                <>
                    <div className="container" style={{margin: "auto"}}>
                        <h2>Materials Handled</h2>
                        <p><Link className="btn btn-primary" to="/MaterialHandled/New">New Material Handled</Link></p>
                    
                        {(columns && rows) && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} />}

                    </div>
                </>
            }
            
            {user["email"] == undefined && <LoginRedirect />}
        </div>
     );
}
 
export default MaterialHandled;